var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentRoute == _vm.addJourney || _vm.currentRoute == _vm.updateJourney)?_c('div',{staticClass:"journey"},[_c('SubmitJourney')],1):_vm._e(),(
      _vm.currentRoute == _vm.addFlow ||
      _vm.currentRoute == _vm.addJourneyFlow ||
      _vm.currentRoute == _vm.updateFlow
    )?_c('div',{staticClass:"flow"},[_c('section',{staticClass:"journey-form-wrapper"},[_c('SubmitBuilder')],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }